/**
 * Helper for implementing event date picker
 */
 (function (eventDateUtils) {

// Validates that the input string is a valid date formatted as "mm/dd/yyyy"
eventDateUtils.isValidDate = (dateString) => {
  // First check for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;
  // Parse the date parts to integers
  let parts = dateString.split("/");
  let day = parseInt(parts[1], 10);
  let month = parseInt(parts[0], 10);
  let year = parseInt(parts[2], 10);
  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;
  let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  // Adjust for leap years
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
    monthLength[1] = 29;
  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
};
    
//Handle Local Storage
eventDateUtils.handleLocalStorage = (type, eventType, eventData = "") => {
  switch (type) {
    case "get":
      return localStorage.getItem(`${eventType}-${"{{ customer.id }}"}`);
      break;
    case "set":
      localStorage.setItem(`${eventType}-${"{{ customer.id }}"}`, eventData);
      break;
    case "remove":
      localStorage.removeItem(`${eventType}-${"{{ customer.id }}"}`);
      break;
    default:
      break;
  }
};
//Handle Update for atributes
//expected => data:{any:any}
eventDateUtils.updateAttributes = async (data) => {
  
  let attributesData = {
    'attributes': data,
   };

   await fetch(`/cart/update.${switch_js_json}`, {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json'
     },
     body: JSON.stringify(attributesData)
   })
   .then(response => {
     return response.json();
   })
   .catch((error) => {
     console.error('Error:', error);
   });
};   

//Enable or Disable Checkout Button
//The href is removed to prevent onclick by user
eventDateUtils.updateUiCheckOutButton = (isDisabled) => {
  };

//Show or Hide a Better looking for checkbox & datepicker
eventDateUtils.updateUIDate = (isCheked, eventDate,locatedID) => {
    if (isCheked) {
        //$("#datePicker_EventDate_"+locatedID).prop('disabled', true);
        $("#checkout_haveEventDate_"+locatedID).prop("checked", true);
        $("#datePicker_EventDate_"+locatedID).css("background-color", "#F2F2F2");
        $("#datePicker_EventDate_"+locatedID).val("");
       } else {
         // $("#datePicker_EventDate_"+locatedID).prop('disabled', false);
           $("#checkout_haveEventDate_"+locatedID).prop("checked", false);
           $("#datePicker_EventDate_"+locatedID).css("background-color", "white");
           $("#datePicker_EventDate_"+locatedID).val(eventDate);
       }
};

 //Handle Event Date Input
  eventDateUtils.enableDate = (locatedID) => {
    let eventDate = jQuery("#datePicker_EventDate_"+locatedID).val();
    if (eventDate) {
        eventDateUtils.handleLocalStorage("set", "event-date", eventDate);
        eventDateUtils.updateUIDate(false, eventDate,locatedID);
        eventDateUtils.updateAttributes({
        event_date: eventDate
      });
    }
  };

  /* The `eventDateUtils.disableDate` function is called when the user check/uncheck the "I have an event
  date" checkbox. */
  eventDateUtils.disableDate = (locatedID) => {
    let eventDate = jQuery("#datePicker_EventDate_"+locatedID).val();
    let hasEventDate = document.getElementById(
      "checkout_haveEventDate_"+locatedID
    ).checked;
    eventDateUtils.updateUIDate(hasEventDate, eventDate,locatedID);
    if (hasEventDate) {
        eventDateUtils.handleLocalStorage("remove", "event-date");
        eventDateUtils.updateAttributes({
        event_date: ""
      });
    } else {
      if (eventDate) {
        eventDateUtils.handleLocalStorage("set", "event-date", eventDate);
        eventDateUtils.updateAttributes({
          event_date: eventDate
        });
      }
    }
  };
/* This function is used to hide the validation message when the user uncheck the "I have an event
date" checkbox. */
  eventDateUtils.showValidateEventDate = (hide) => {
/*     if(hide) {
      $("#validate_eventdate").hide();
      $("#validate_eventdate_quickCart").hide();
    }else{
      $("#validate_eventdate").show();
      $("#validate_eventdate_quickCart").show();
    } */
  }
  eventDateUtils.validateButtonCheckout = (block) => {
    const checkoutButtonSelector = template_location === "cart" ? "#cart-checkout" : "#cart-sidebar-checkout";
    const shouldDisable = Boolean(block);
    $(checkoutButtonSelector).prop('disabled', shouldDisable);
    event_date_accept = !shouldDisable;
  }
})((window.eventDateUtils = window.eventDateUtils || {}));
